import { importProductsXlsx } from "./import-products-xlsx";
import productsTab from "./products-tab.json";

export const products = {
	importProductsXlsx,
	productsTab,
};
